import React, { FunctionComponent } from "react";

/** Place where you need a horizontal gap in your layout */
export const HorizontalGap: FunctionComponent<{ height: string; className?: string }> = ({ height, className }) => (
    <hr className={className} role="presentation" style={{ background: "transparent", marginTop: height, border: "none" }} />
);
